import React from 'react';
import {Section,SectionHeader} from '../ui/Section';
import SafeIcon from '../../common/SafeIcon';
import {FiInfo, FiCalendar, FiCreditCard} from 'react-icons/fi';

export const Policies=()=> {
const CEREMONY_IMAGE="https://ik.imagekit.io/aeu02xvjgn/Padua-Hills-Weddings-Danielle-and-Brian-42.jpg?updatedAt=1776897468567";

return (
  <Section id="policies" bg="bg-white">
    <div className="grid lg:grid-cols-2 gap-12 items-start">
      <div className="space-y-8 order-2 lg:order-1">
        <SectionHeader title="Ceremony & Policies" subtitle="Essential planning and booking information." className="text-left mx-0" />
        
        <div className="grid sm:grid-cols-2 gap-4">
          <div className="bg-aged-ivory p-6 rounded-xl border border-warm-stone/20">
            <h4 className="font-serif text-lg text-deep-charcoal mb-1">Ceremony + Reception</h4>
            <p className="text-olive-grove font-bold mb-3">$2,000 Wedding Ceremony Fee</p>
            <p className="text-[11px] text-deep-charcoal/70 leading-relaxed">
              Includes: Gazebo prep, up to 225 white chairs, guest book/gift/ceremony tables with linen, white aisle runner (on request), breakdown/cleanup, 1-hour rehearsal, and Bridal Suite.
            </p>
          </div>
          <div className="bg-white p-6 rounded-xl border border-warm-stone/20 shadow-sm">
            <h4 className="font-serif text-lg text-deep-charcoal mb-1">Ceremony Only</h4>
            <p className="text-estate-bronze font-bold mb-3">$2,500 – $3,500</p>
            <p className="text-[11px] text-deep-charcoal/70 leading-relaxed">
              Typically offered 9:00 AM – 12:00 PM. Includes ceremony site, standard setup, and bridal room access.
            </p>
          </div>
        </div>

        <div className="bg-deep-charcoal text-white p-8 rounded-2xl relative overflow-hidden shadow-2xl">
          <div className="absolute top-0 left-0 w-1 h-full bg-estate-bronze"></div>
          <h4 className="font-serif text-xl mb-6 flex items-center gap-2">
            <SafeIcon icon={FiCalendar} className="text-estate-bronze" /> Booking & Payments
          </h4>
          <ul className="space-y-3 text-sm font-light text-white/80">
            <li className="flex items-start gap-2"><span className="text-estate-bronze">•</span> Booking Retainer: $8,000 (Check or CC w/ 3% fee)</li>
            <li className="flex items-start gap-2"><span className="text-estate-bronze">•</span> Second Retainer: $8,000 (Due 3 months prior)</li>
            <li className="flex items-start gap-2"><span className="text-estate-bronze">•</span> Final Guest Count: Due 2 weeks prior (Can only go up)</li>
            <li className="flex items-start gap-2"><span className="text-estate-bronze">•</span> Final Balance: Due 2 days prior (Cashier's Check only)</li>
          </ul>
        </div>

        <div className="bg-aged-ivory p-8 rounded-2xl border border-warm-stone/30">
          <div className="flex items-center gap-3 mb-4">
            <SafeIcon icon={FiInfo} className="text-estate-bronze w-5 h-5" />
            <h4 className="font-serif text-lg text-deep-charcoal">Important Notes</h4>
          </div>
          <ul className="space-y-3">
            {[
              "Full-service events are subject to a 22% administrative fee & sales tax.",
              "Outdoor dining increases the administrative fee to 25%.",
              "Administrative fee is for overhead and is not a gratuity.",
              "No outside alcohol allowed anywhere (including Bridal Suite).",
              "Nothing may be attached to walls; no glitter, confetti, or floor tape.",
              "Cakes/desserts brought in: $3.00/pp cutting & service fee."
            ].map((note, i) => (
              <li key={i} className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-estate-bronze mt-1.5 flex-shrink-0"></span>
                <span className="text-xs text-deep-charcoal/70 leading-relaxed">{note}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="relative order-1 lg:order-2 lg:sticky lg:top-24">
        <div className="aspect-[4/5] rounded-2xl overflow-hidden shadow-float">
          <img 
            src={CEREMONY_IMAGE} 
            alt="Ceremony at Padua Weddings" 
            className="w-full h-full object-cover" 
          />
        </div>
        <div className="absolute -bottom-4 -right-4 w-24 h-24 border-b-2 border-r-2 border-estate-bronze/30 rounded-br-2xl hidden sm:block"></div>
      </div>
    </div>
  </Section>
);
};